import { motion } from "framer-motion";
import { FileText, BadgePercent, PlayCircle } from "lucide-react";
import { SectionHead } from "./Reveal";

const POSITIONS = [
  "md:col-span-8 md:row-span-2",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4 md:row-span-2",
  "md:col-span-4",
];

export default function BentoGrid({ products = [], onBuy }) {
  if (products.length === 0) return null;

  return (
    <section id="featured" className="py-24 bg-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          index="01" label="Featured This Week"
          title="Handpicked bundles, direct from the topper's desk"
          sub="Har product khud verify kiya gaya — instant download ke saath."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-5 md:auto-rows-[230px]" data-testid="bento-grid">
          {products.slice(0, 5).map((p, i) => (
            <motion.button
              key={p.id}
              onClick={() => onBuy(p, "buy")}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: Math.min(i * 0.08, 0.4) }}
              className={`card-lift group relative overflow-hidden rounded-3xl border border-slate-200/70 bg-ink text-left min-h-[240px] md:min-h-0 ${POSITIONS[i % POSITIONS.length]}`}
              data-testid={`bento-card-${p.id}`}
            >
              {p.cover_image_url && (
                <img src={p.cover_image_url} alt={p.title} loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
              <div className="relative flex h-full flex-col justify-between p-6 sm:p-7">
                <div className="flex items-start justify-between gap-3">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-amber-400 backdrop-blur">
                    {p.ptype === "course" ? <PlayCircle size={12} /> : <FileText size={12} />} {p.category}
                  </span>
                  {i === 0 && (
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] font-bold text-ink">
                      <BadgePercent size={12} /> Bestseller
                    </span>
                  )}
                </div>
                <div>
                  <h3 className={`font-display font-extrabold leading-tight text-white ${i === 0 ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"}`}>{p.title}</h3>
                  <div className="mt-3 flex items-center gap-3">
                    <span className="font-display text-xl font-extrabold text-amber-400">{p.price === 0 ? "Free" : `₹${p.price.toLocaleString("en-IN")}`}</span>
                    {p.original_price > p.price && p.price > 0 && (
                      <span className="text-sm text-slate-400 line-through">₹{p.original_price.toLocaleString("en-IN")}</span>
                    )}
                    <span className="ml-auto rounded-full bg-white/10 px-4 py-2 text-xs font-bold text-white backdrop-blur transition-colors group-hover:bg-amber-500 group-hover:text-ink">
                      Buy Now →
                    </span>
                  </div>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
